export default function reactOnly(state = false, _action) {
  return process.env.REACT || state;
}
